import { render, staticRenderFns } from "./Pictionary.vue?vue&type=template&id=5476d17a&scoped=true"
import script from "./Pictionary.vue?vue&type=script&lang=ts"
export * from "./Pictionary.vue?vue&type=script&lang=ts"
import style0 from "./Pictionary.vue?vue&type=style&index=0&id=5476d17a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5476d17a",
  null
  
)

export default component.exports